module.exports = ".row {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n.welcome-section {\n  font-size: 2.5rem;\n  margin-left: 15px; }\n\n.welcome-section-user {\n    font-size: 3.5rem; }\n\n.welcome-section-user span {\n      font-style: italic; }\n\n.welcome-section-description {\n  font-size: 2.5rem;\n  margin-left: 15px;\n  padding: 13px; }\n\n.information-text-container {\n  font-size: 1.6rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/views/dashboard-view/dashboard-view.component.scss
// module id = ./src/app/+app-custom/views/dashboard-view/dashboard-view.component.scss
// module chunks = main